import { CompanyCenterCreateRequestDTO, CompanyCenterDTO, CompanyCenterUpdateRequestDTO, FindAllCompanyCentersResponseDTO, FindAllFiltersCompanyCentersDTO } from "./dto"
import { CompanyCenterServiceImpl } from "./serviceImpl"


export interface CompanyCenterService {
    getCompanyCenters(filters: FindAllFiltersCompanyCentersDTO): Promise<FindAllCompanyCentersResponseDTO>
    getCompanyCenterById(id: string): Promise<CompanyCenterDTO>
    updateCompanyCenter(id: string, data: CompanyCenterUpdateRequestDTO): Promise<void>
    createCompanyCenter(data: CompanyCenterCreateRequestDTO): Promise<number>
    deleteCompanyCenter(id: string): Promise<void>
    removeCompanyCenter(id: string): Promise<void>
}

export function NewCompanyCenterService(): CompanyCenterService {
    return new CompanyCenterServiceImpl();
}
